import React from "react";
import "../Styles/view_more.css";




const ViewMore = () => {
  return (
    <div className="viewmore-page">

      {/* ===== SECTION 1 ===== */}
      <section className="viewmore-hero">
        <div className="viewmore-container">

        {/* LEFT SIDE */}
<div className="viewmore-left">
  <h1>Outstanding Workplaces Conference</h1>

  <p className="viewmore-subtitle">
    "Building a People-Centric Culture: Strategies for Success"
  </p>

  {/* Row 1 */}
  <div className="viewmore-row">
    <div className="viewmore-detail-box">
     <img src="/assets/viewmore_2.png" alt="calendar" className="icon" />
      <span>11th October, 2025 (Saturday)</span>
    </div>

    <div className="viewmore-detail-box">
     <img src="/assets/viewmore_3.png" alt="clock" className="icon" />
      <span>10:00 AM - 1:00 PM</span>
    </div>
  </div>

  {/* Row 2 */}
  <div className="viewmore-location-box">
   <img src="/assets/viewmore_4.png" alt="location" className="icon" />
    <span>Bloom Hub Hotel, Guindy, Chennai.</span>
  </div>

</div> {/* ✅ IMPORTANT: CLOSE LEFT HERE */} 
          {/* RIGHT SIDE */}
          <div className="viewmore-right">
            <img src="/assets/viewmore_1.png" alt="event" />
            <div className="viewmore-circle"></div>
          </div>

        </div> {/* ✅ CLOSED CONTAINER */}
      </section> {/* ✅ CLOSED SECTION 1 */}


      {/* ===== SECTION 2 ===== */}
      <section className="viewmore-about">
        <div className="viewmore-about-container">

          <h2>About the Event</h2>

          <p>
            Vanakkam HRD x Outstanding Workplaces for an exclusive discussion on "Building a People-Centric Culture: Strategies for Success"!
          </p>

          <ul>
            <li>Defining and living core values that drive organizational success.</li>
            <li>Fostering open communication and feedback for transparency and trust.</li>
            <li>Prioritizing employee well-being and work-life balance for a healthy workforce.</li>
            <li>Recognizing and rewarding contributions to boost morale and motivation.</li>
            <li>Building a culture of inclusivity, diversity, and empathy.</li>
          </ul>

        </div>
      </section>

    </div>
  );
};

export default ViewMore;